import React from 'react'
import './PrivacyPolicy.css';
import blud from "../../assets/images/logo.png";


export default function PrivacyPolicy() {
    return (
        <div className="privacy-policy container">
            <div className="text-center">
                <img src={blud} style={{width: 100}} alt="logo" />
            </div>

            <h3 className="text-center fw-700 my-3">Data Protection & Privacy Policy</h3>
            <p>BLUD is a demand-supply optimisation solution for transfusion medicine (Blood & Blood Components) completely conceived, designed, developed and owned by Serapis Knowledge Solutions Private Limited.</p>
            <p>
                At BLUD, accessible from <b>www.BLUD.app</b>, one of our main priorities is the privacy of our website visitors and application users. This Data Protection & Privacy Policy document contains types of information that is collected and recorded by BLUD and how we use it.
     </p>
            <p>
                If you have additional questions or require more information about our Data Protection & Privacy Policy, do not hesitate to contact us.
     </p>
            <p>
                This Data Protection & Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in BLUD. This policy is not applicable to any information collected offline or via channels other than this website.
     </p>

            <h6>Consent</h6>
            <p>
                By using our website or the BLUD App, you hereby consent to our Privacy Policy and agree to its terms.
     </p>
            <h6>Information we collect
</h6>



            <p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>
            <p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, location, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>
            <p>When you register for an Account, we may ask for your contact information, including items such as name, institution name, address, email address and telephone number.</p>
            <h6>Information sharing and disclosure</h6>
            <p>Data privacy and secrecy are of paramount importance to every individual and organisation and we are equally concerned about the same. We DO NOT SELL your personal information to anyone for any purpose, be it target marketing or promotional communication, etc. </p>
            <h6>How we use your information</h6>
            <p className="mb-1">We use the information we collect in various ways, including to:</p>
            <ul className="remove-list-style pl-3">
                <li> &#8213; Provide, operate, and maintain our website and the BLUD App</li>
                <li>&#8213; Improve, personalise, and expand our website and the BLUD App</li>
                <li>&#8213; Understand and analyse how you use our website and the BLUD App</li>
                <li>&#8213; Develop new solutions, services, features, improve the functionality and UX of the BLUD App</li>
                <li>&#8213; Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
                <li>&#8213; Send you emails related to your subscription, activity snapshot, profile security and new features of BLUD App</li>
                <li>&#8213; Send you emails about enhanced features that match with your profile</li>
                <li>&#8213; Detect and prevent fraud</li>

            </ul>

            <h6>Log Files</h6>
            <p>
                BLUD follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analysing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
            </p>
            <h6>Cookies and Web Beacons</h6>

            <p>Like any other website, BLUD uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimise the users' experience by customising our web page content based on visitors' browser type and/or other information.</p>
            <p>You have the opportunity to configure your browser to accept/reject cookies or to notify you when a cookie was issued. Rejecting cookies, however, means that certain personalised services on the Website cannot be provided to you.</p>
            <p>Please obtain help from your system administrator for more information on how to disable and delete cookies.</p>
            <p>For more general information on cookies, please read<span className="primary-color"> "What Are Cookies" from Cookie Consent</span>.</p>
            <h6>Advertising Partners Privacy Policies</h6>
            <p>As a business productivity suit solution provider,<i> we do not support or encourage or solicit advertisements on our website or apps</i>. Should this policy change in principle, we shall elaborate this session.</p>
            <h6>CCPA Privacy Rights (Do Not Sell My Personal Information)</h6>
            <p className="mb-1">Under the CCPA, among other rights, California consumers have the right to:</p>
            <ul className="remove-list-style pl-3">
                <li> &#8213; Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.
</li>
                <li> &#8213; Request that a business delete any personal data about the consumer that a business has collected.
</li>
                <li>&#8213; Request that a business that sells a consumer's personal data, not sell the consumer's personal data.
</li>


            </ul>
            <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
            <h6>GDPR Data Protection Rights</h6>
            <p className="mb-1">We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
            <ul className="remove-list-style pl-3">
                <li> &#8213; The right to access: You have the right to request copies of your personal data. We may charge you a small fee for this service.

</li>
                <li>&#8213; The right to rectification: You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.
</li>
                <li>&#8213; The right to erasure: You have the right to request that we erase your personal data, under certain conditions.
</li>

                <li>&#8213; The right to restrict processing: You have the right to request that we restrict the processing of your personal data, under certain conditions.

</li>

                <li>&#8213; The right to object to processing: You have the right to object to our processing of your personal data, under certain conditions.
</li>

                <li>&#8213; The right to data portability: You have the right to request that we transfer the data that we have collected to another organisation, or directly to you, under certain conditions.

</li>



            </ul>

            <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
            <h6>Children's Information</h6>
            <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
            <p>BLUD does not knowingly collect any Personal Identifiable Information from children under the age of 13. However, such data may be acquired (as users) from participating medical institutions for better service delivery. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>
            <h6>Synopsis</h6>
            <ol>
                <li>User has every right and access to the personal data created or stored by the user in BLUD.</li>
                <li>BLUD provides a platform for efficient supply chain management of Blood & Blood Components for Transfusion Medicine.</li>
                <li>BLUD stores the user data for the purpose and period defined below:
                <div className="table-responsive">

<table className="table">

                        <tbody>
                            <tr>
                                <td>What are we storing?</td>
                                <td>How long?</td>
                                <td>Why do we need that?</td>
                                <td>
                                    Shared?
</td>
                                <td>What do we share?</td>
                                <td>With whom?</td>
                                <td>Why do we share?</td>
                            </tr>
                            <tr>
                                <td>User Profile data: (Name, Age, Blood Type, Email, Phone No., etc.]
</td>
                                <td>3 yr. after account deletion</td>
                                <td>Create User Account and link it for login access and BLUD user identification </td>
                                <td>Yes</td>
                                <td>BLUD User Name, Age, Blood Type, Contact Info of Donors</td>
                                <td>Hospitals, Blood Banks</td>
                                <td>To connect blood demand with supply for fulfilment</td>

                            </tr>
                            <tr>
                                <td>Location</td>
                                <td>Static Location as selected by User in profile</td>
                                <td>Geofencing and send alerts & notifications for demands & supply in area of radius</td>
                                <td>NO</td>
                                <td>User Profile Data within the area</td>
                                <td>Blood Bank & Patients seeking Blood</td>
                                <td>For patients & Blood Banks to request Blood for Transfusion</td>


                            </tr>
                            <tr>
                                <td>Attachments</td>
                                <td>Tagged to User Profile</td>
                                <td>To preserve Medical History of Users for future reference</td>
                                <td>Yes</td>
                                <td>Medical History</td>
                                <td>Doctors</td>
                                <td>To determine the course of treatment and medication</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </li>
                <li>
                    BLUD App does not share any user data to any third party. However, should it be required by the law of the land or by any investigation or law enforcement agency, user data shall be shared for the defined purpose and time period.
                </li>
                <li>Internally, we may also analyse the app usage and user behavioural pattern to enhance their experience through integration and feature upgrades. This in no way invades privacy or breach security.</li>
            </ol>

            <h6>Contact us
</h6>
            <p>For any concerns or clarifications regarding Data Protection Policy, feel free to write to us at <span ><a href="mailto:Support@BLUD.app" className="primary-color">Support@BLUD.app </a></span>  </p>
            <small>Version 1.0; Last updated on May 06, 2021</small>
            <hr className="my-1"/>
            <p className="mb-1"> <small className="mb-1">Amendment History:</small></p>
           
            <table className="table">

                <tbody>
                    <tr>
                        <td>  <small>  06/May/2021</small>
</td>
                        <td>
                        <small> V1.0</small>

</td>
                        <td>  <small>Data Protection & Privacy Policy published</small></td>
                    </tr>
                    <tr>
                        <td>  <small>Date</small></td>
                        <td>  <small>Version</small></td>
                        <td>  <small>Release Notes</small></td>
                    </tr>

                </tbody>
            </table>
        </div>
    )
}
